import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Auth() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleSignIn(e) {
    e.preventDefault()
    setLoading(true)
    setError(null)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoContainer}>
          <img src="/logo.jpg" alt="Reflections" style={styles.logo} />
          <div style={styles.portalBadge}>STAFF PORTAL</div>
        </div>

        <form onSubmit={handleSignIn} style={styles.form}>
          <h2 style={styles.title}>Sign In</h2>
          <p style={styles.subtitle}>Access your staff dashboard</p>

          <label style={styles.label}>Email</label>
          <input
            style={styles.input}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
          />

          <label style={styles.label}>Password</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          {error && <p style={styles.error}>{error}</p>}

          <button
            style={styles.button}
            type="submit"
            disabled={loading}>
            {loading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    backgroundColor: '#111',
    border: '1px solid #222',
    borderRadius: '2px',
    padding: '40px',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '32px',
  },
  logo: {
    width: '220px',
    height: 'auto',
  },
  portalBadge: {
    fontSize: '9px',
    color: '#555',
    letterSpacing: '3px',
    border: '1px solid #222',
    padding: '3px 10px',
    borderRadius: '2px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#F5F0E8',
    marginBottom: '4px',
    letterSpacing: '0.5px',
  },
  subtitle: {
    fontSize: '12px',
    color: '#444',
    marginBottom: '20px',
    letterSpacing: '0.3px',
  },
  label: {
    fontSize: '10px',
    fontWeight: '600',
    color: '#555',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginTop: '12px',
    marginBottom: '6px',
    fontFamily: 'Montserrat, sans-serif',
  },
  input: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#0a0a0a',
    border: '1px solid #222',
    borderRadius: '2px',
    color: '#F5F0E8',
    fontSize: '15px',
    fontFamily: 'Montserrat, sans-serif',
    outline: 'none',
  },
  error: {
    color: '#ef4444',
    fontSize: '13px',
    marginTop: '8px',
  },
  button: {
    marginTop: '24px',
    padding: '16px',
    backgroundColor: '#D4AF77',
    color: '#000',
    border: 'none',
    borderRadius: '2px',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '3px',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    transition: 'background-color 0.2s',
  },
}